import TopBarCalendar from '@/components/TopBars/filters/TopBarCalendar/TopBarCalendar.redux';
import TopBar from '@/components/TopBars/TopBar';
import { employeePayrollModesIds } from '@/constants/viewDateModes';

const EmployeePayrollTopBar = () => <TopBar leftElements={[<TopBarCalendar modes={employeePayrollModesIds} />]} />;

export default EmployeePayrollTopBar;
